import React from 'react'
import { Provider } from 'react-redux'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { SubscribeRestaurantLocation } from 'components'
import Routes from 'routes'
import { store } from 'store'

library.add(fas)

function App() {
  return (
    <Provider store={store}>
      <>
        <Routes />
        <SubscribeRestaurantLocation />
      </>
    </Provider>
  )
}

export default App
